import { FC, ReactNode } from 'react'

import { cn } from '@/app/utils'
import {
  ButtonSizes,
  ButtonVariants
} from '@/components/shared/button/ui/Button.types'
import {
  FileUploader,
  UploadedFileType
} from '@/components/shared/file-uploader'

import { useUploadFiles } from '../hooks/useUploadFiles'
import FilesPreviewModal from './FilesPreviewModal'
import UploadedFilesList from './UploadedFilesList'

type Props = {
  multiple?: boolean
  accept?: string[]
  disabled?: boolean
  buttonVariant?: ButtonVariants
  buttonSize?: ButtonSizes
  buttonWrapperClassName?: string
  className?: string
  onUpload?: (e: UploadedFileType[]) => void
  defaultFiles?: UploadedFileType[]
  buttonText?: string
  buttonIcon?: ReactNode
  buttonClassName?: string
  isUploading?: boolean
  setUploadProgress?: (_: number) => void
}

const UploadFiles: FC<Props> = ({
  disabled,
  accept,
  multiple = true,
  buttonVariant,
  buttonSize,
  buttonWrapperClassName,
  className,
  onUpload,
  defaultFiles,
  buttonText,
  buttonIcon,
  buttonClassName,
  isUploading,
  setUploadProgress
}) => {
  const { files, handleUpload, handleRead, handleDeleteFile, preview } =
    useUploadFiles({
      defaultFiles,
      onUpload,
      multiple,
      setUploadProgress
    })

  return (
    <div className={cn(className)}>
      <UploadedFilesList
        files={files}
        onDelete={handleDeleteFile}
        handleFileAction={preview.handleFileAction}
        disabled={disabled}
      />
      <FileUploader
        disabled={disabled}
        onUpload={handleUpload}
        onRead={handleRead}
        multiple={multiple}
        accept={accept}
        buttonVariant={buttonVariant}
        buttonSize={buttonSize}
        buttonWrapperClassName={buttonWrapperClassName}
        buttonText={buttonText}
        buttonIcon={buttonIcon}
        buttonClassName={buttonClassName}
        isUploading={isUploading}
      />
      <FilesPreviewModal
        isModalOpen={preview.isModalOpen}
        currentFiles={preview.currentFiles}
        activeIndex={preview.activeIndex}
        onClose={preview.handleCloseModal}
      />
    </div>
  )
}

export default UploadFiles
